export const DROPDOWN_ROOT_CLASS = 'base-dropdown';
export const DROPDOWN_CONTAINER_CLASS = 'dropdown-container';
export const DEBOUNCE_DELAY = 150;

export const CSS_CLASSES = {
  root: DROPDOWN_ROOT_CLASS,
  rootOpened: '_opened',
  overflow: 'base-dropdown_overflow',
  toggleWrapper: 'base-dropdown_toggle-wrapper',
  dropdownWrapper: 'base-dropdown_dropdown-wrapper',
  contentWrapper: 'base-dropdown_content-wrapper',
  content: 'base-dropdown_content',
} as const;